export const DisplayMode = {
  FORCE: 'force',
  SOFT: 'soft',
};
